export const TOGGLE_INSTALL_COCOPARKS = 'TOGGLE_INSTALL_COCOPARKS'

export function displayInstallCocoparksReducer(state = false, action) {
    switch (action.type){
        case TOGGLE_INSTALL_COCOPARKS:
            return action.payload
        default: return state
    }
}